<!--/*
* @name: 客户反馈
* @description: 客户反馈
* @author: zefeng(zefeng.chen@shengyc.com)
* @Date: 2020-02-17 10:42:18
* @LastEditTime: 2020-02-17 10:42:18
*/-->

<template>
    <div id="feedback_container" ref="main">
        <nav-back :headTitle="FC_type === 'feedback' ? '意见反馈' : '投诉'" :bg="'#3766E1'" color="#FFFFFF">
        </nav-back>
        <div class="feedback_main" :class="is_Safari() ? 'b100' : null" v-myloading="loading">
            <!-- banner图 -->
            <div class="img-container" v-if="FC_type === 'feedback'">
                <img class="tip" src="@/assets/images/img_feedback.png" alt />
            </div>
            <van-form @submit="onSubmit" :show-error="false" ref="formbox">
                <!-- 反馈、投类型 -->
                <div
                    class="form_feedbackType"
                    :style="FC_type === 'complaints' ? 'padding-top:5px;' : ''"
                    v-if="opinionColumns.length"
                >
                    <van-field
                        readonly
                        required
                        v-model="params.feedbackText"
                        name="feedbackType"
                        :label="`${componentText}类型`"
                        :placeholder="`请选择${componentText}类型`"
                        @click="showFCbox"
                    />
                    <i class="iconfont iconyoujiantou_huaban icon" @click="showFCbox"></i>
                </div>
                <!-- 设备编号 -->
                <div class="form_equipmentCode" v-if="this.params.type == 1">
                    <van-field
                        clearable
                        label="设备编号"
                        type="text"
                        v-model="params.equipment_code"
                        ref="equipment_code"
                        placeholder="请输入"
                    ></van-field>
                    <span class="select" @click="$_selectEquipment" v-if="isLogin">选择</span>
                    <img
                        src="../../assets/images/icon_scan_feedback.png"
                        class="scan_img"
                        @click="scanStart()"
                        v-if="$store.state.wxConfigOk"
                    />
                </div>
                <!-- 服务单号 服务类型才有-->
                <div class="form_serviceCode" v-if="this.params.type == 3">
                    <van-field
                        clearable
                        label="服务单号"
                        type="text"
                        v-model="params.serviceCode"
                        ref="serviceCode"
                        placeholder="请输入"
                    ></van-field>
                    <!-- 盛云宝才可以选择 -->
                    <span
                        class="select"
                        @click="selectServiceorderFun"
                        v-if="$store.state.account_origin === 'smas'"
                        >选择</span
                    >
                </div>
                <!-- 人员 人员类型才有-->
                <div class="form_member" v-if="this.params.type == 4">
                    <van-field
                        clearable
                        label="人员"
                        type="text"
                        v-model="params.member"
                        ref="member"
                        placeholder="请输入"
                    ></van-field>
                </div>
                <!-- 配件相关  配件类型才有 -->
                <template v-if="this.params.type == 5">
                    <!-- 配件名称 -->
                    <div class="form_accessoriesName">
                        <van-field
                            clearable
                            label="配件名称"
                            type="text"
                            v-model="params.accessoriesName"
                            ref="accessoriesName"
                            placeholder="请输入"
                        ></van-field>
                        <span class="select" @click="selectAccessoriesFun" v-if="isLogin">选择</span>
                    </div>
                    <!-- 品号（编号） -->
                    <div class="form_accessoriesCode">
                        <van-field
                            clearable
                            label="品号（编号）"
                            type="text"
                            v-model="params.accessoriesCode"
                            ref="accessoriesCode"
                            placeholder="请输入"
                            @blur="iosKeyboardDown"
                        ></van-field>
                    </div>
                    <!-- 配件型号 -->
                    <div class="form_accessoriesModel" :style="!isLogin ? 'padding-bottom:0;' : ''">
                        <van-field
                            clearable
                            label="配件型号"
                            type="text"
                            v-model="params.accessoriesModel"
                            ref="accessoriesModel"
                            placeholder="请输入"
                            @blur="iosKeyboardDown"
                        ></van-field>
                    </div>
                    <!-- 灰色条 纯样式标签-->
                    <div
                        v-if="params.type === 5 && !isLogin"
                        style="height: 5px; background: #fff; width: 100%; margin-top: 22px"
                    ></div>
                </template>
                <!-- 系统终端 -->
                <div class="form_systemType" v-if="params.type === 2 && systemTypeColumns.length">
                    <van-field
                        readonly
                        v-model="params.systemTypeText"
                        name="systemType"
                        label="系统终端"
                        placeholder="请选择系统终端"
                        @click="showSystemType = true"
                    />
                </div>
                <!-- 投诉问题  投诉才有 -->
                <div class="form_complainType" v-if="FC_type === 'complaints' && complainColumns.length">
                    <van-field
                        readonly
                        required
                        v-model="params.complaintText"
                        name="complaintText"
                        label="投诉问题"
                        :placeholder="`请选择投诉问题`"
                        @click="showComplainType = true"
                    />
                    <i class="iconfont iconyoujiantou_huaban icon" @click="showComplainType = true"></i>
                </div>
                <!-- 反馈、投诉内容 -->
                <div class="form_feedbackContent">
                    <van-field
                        v-model="params.feedbackContent"
                        rows="1"
                        autosize
                        required
                        :rules="[{ pattern: /.+/, message: `请输入${componentText}内容` }]"
                        :label="`${componentText}内容`"
                        type="textarea"
                        maxlength="200"
                        placeholder="请输入意见或建议，200字以内"
                        @blur="iosKeyboardDown"
                    />
                </div>
                <!-- 附件 -->
                <div class="form_file">
                    <p>
                        <span>附件</span>
                        <span
                            >(<span style="color: #999">{{ imgArr.length + videoArr.length }}</span
                            >/10)</span
                        >
                    </p>
                    <PictureList
                        :actions="actions"
                        @imgArr="getImgArr"
                        @videoArr="getVideoArr"
                        :acceptIn="'video/* image/*'"
                        :fileMaxNum="10"
                    />
                </div>
                <!-- 个人信息 -->
                <template>
                    <h3 class="person-title">个人信息</h3>
                    <!-- <h3 style="height: 1500px;">个人信息</h3> -->
                    <div class="form_personalMsg">
                        <!-- 公司名称 -->
                        <div class="companyName" v-viewInput="{ scrollBox: '.feedback_main' }">
                            <van-field
                                v-model="params.personalMsg.companyName"
                                name="personalMsgCompanyName"
                                label="公司名称"
                                placeholder="请输入"
                                @blur="iosKeyboardDown"
                            />
                        </div>
                        <!-- 姓名 -->
                        <div class="name" v-viewInput="{ scrollBox: '.feedback_main' }">
                            <van-field
                                v-model="params.personalMsg.name"
                                name="personalMsgName"
                                label="姓名"
                                placeholder="请输入"
                                @blur="iosKeyboardDown"
                            />
                        </div>
                        <!-- 手机号码 -->
                        <div class="phone" v-viewInput="{ scrollBox: '.feedback_main' }">
                            <van-field
                                v-model="params.personalMsg.phone"
                                name="personalMsgPhone"
                                maxlength="30"
                                label="手机号码"
                                placeholder="请输入"
                                type="tel"
                                :rules="[{ validator: validatorPhone, message: '请输入正确的手机号码' }]"
                                @blur="iosKeyboardDown"
                            />
                        </div>
                    </div>
                </template>
                <!-- <div class="bottom-btn"> -->
                <div class="bottom-btn" v-if="opinionColumns.length">
                    <van-button class="submit-btn" native-type="submit">
                        <span>提交</span>
                    </van-button>
                </div>
            </van-form>
        </div>
        <!-- ********************  底部弹层  ******************** -->
        <!-- 反馈类型选择弹层 -->
        <van-popup v-model="showFeedbackTypeSelect" position="bottom" :style="{ height: '40vh' }">
            <van-picker
                :title="`${componentText}类型`"
                show-toolbar
                :default-index="feedbackDefaultIndex"
                :columns="opinionColumns"
                @confirm="opinionOnConfirm"
                @cancel="opinionOnCancel"
                :value-key="'typeName'"
            />
        </van-popup>
        <!-- 投诉问题选择弹层 -->
        <van-popup v-model="showComplainType" position="bottom" :style="{ height: '40vh' }">
            <van-picker
                title="投诉问题"
                show-toolbar
                :default-index="0"
                :columns="complainColumns"
                @confirm="complainOnConfirm"
                @cancel="complainOnCancel"
            />
        </van-popup>
        <!-- 系统终端选择弹层 -->
        <van-popup v-model="showSystemType" position="bottom" :style="{ height: '40vh' }">
            <van-picker
                title="投诉类型"
                show-toolbar
                :default-index="0"
                :columns="systemTypeColumns"
                @confirm="systemTypeOnConfirm"
                @cancel="systemTypeOnCancel"
                :value-key="'typeName'"
            />
        </van-popup>
    </div>
</template>
<script>
import PictureList from '@/components/common/PictureList.vue'
import { pathOr, getRandomCode, getUrlKey} from '@/config/Utils'
import {
    feedbackInfo,
    get_feedback_type,
    get_complain_type,
    postHuaWeiOBS,
    get_file_upload_params,
    get_qr_base_info,
    getCustomerByEquipment,
    get_scan_qr_permission
} from '@/service/getData'
import { Toast } from 'vant'
import { _handleMedia } from '@/config/Upload'
import NavBack from '@/components/NavBack/index.vue'
export default {
    name: 'FeedbackScreen',
    components: {
        PictureList,
        NavBack
    },
    props: {
        // 组件类型 反馈还是投诉
        FC_type: {
            type: String,
            default: 'feedback' // 投诉 complaints  反馈 feedback
        }
    },
    watch: {
        FC_type: {
            handler(val) {
                this.getFeedbackType()
                if (val === 'complaints') {
                    this.getComplainType()
                }
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            document.title = vm.FC_type === 'feedback' ? '意见反馈' : '投诉'
        })
    },
    computed: {
        componentText() {
            return this.FC_type === 'feedback' ? '反馈' : '投诉'
        },
        isLogin() {
            return !(
                this.$store.state.account_origin === 'not_staff' || this.$store.state.account_origin === ''
            )
        }
    },
    data() {
        return {
            // 表单数据
            params: {
                type: -1,
                complaintText: '',
                feedbackContent: '', // 反馈、投诉内容
                feedbackText: '设备',
                serviceCode: '', // 服务单号
                member: '', // 人员
                accessoriesName: '', // 配件名称
                accessoriesCode: '', // 配件品号
                accessoriesModel: '', // 配件型号
                systemTypeText: 'Smas app', // 系统终端
                // 个人信息
                personalMsg: {
                    companyName: '',
                    name: '',
                    phone: ''
                },
                associatedObjectId: '', // 选择、扫码的时候带出的id
                equipment_id: '', // 设备id
                equipment_code: '', // 设备编号
                equipment_name: '' // 设备名称
            },
            // 选择、扫码，保存信息，如果最后的表单信息与选择的不一致，则清空
            cacheParams: {},
            showFeedbackTypeSelect: false, // 展示反馈、投诉类型弹层
            showSystemType: false, // 展示系统终端弹层
            showComplainType: false, // 展示投诉问题选择弹层
            // 反馈类型，盛云猫登录只能反馈、投诉‘系统’类型
            opinionColumns: [],
            // 投诉问题
            complainColumns: [],
            // 系统类型
            systemTypeColumns: [],
            filesList: [],
            imgArr: [], //上传图片选择的图片数组
            videoArr: [],
            timer: null,
            saveFlag: true,
            feedbackDefaultIndex: 0,
            loading: false,
            actions: [{ name: '拍照' }, { name: '录像' }, { name: '从相册选取' }]
        }
    },
    created() {
        // ios 微信返回上一页会读取缓存的快照页面，做刷新处理
        window.addEventListener('pageshow', function(event) { 
            if (event.persisted) {
                window.location.reload()
            }
        })
        this.getMainPermission()
    },
    activated() {
        this.saveRouteData()
    },
    methods: { 
        getMainPermission() {
            // 当租户id存在且跟当前登录不一样
            let platform_id = getUrlKey('platformId') || (this.$route && this.$route.query.platformId)
            let old_platform_id = this.$store.state.platform_id
            // 如果未登录或者platform_id跟登录的不一样
            if (
                platform_id &&
                (((this.$store.state.account_origin === 'not_staff' || !this.$store.state.account_origin) && !this.$store.state.historyAccountType)
                    || platform_id !== old_platform_id
                )
            ) {
                // 保存platfrom_id
                this.$store.commit('updatePlatformId', platform_id)
                // 退出登录
                this.$store.commit('updateHistoryAccountType', '')
                // 获取权限
                get_scan_qr_permission({
                    platformId: platform_id
                }).then(res => {
                    this.$store.commit('set_account_origin', pathOr('', ['user_origin'], res))
                    this.$store.commit('set_account_permission', pathOr({}, ['qr_permission'], res)) 
                    this.$store.commit('get_user_origin', pathOr('', ['user_origin'], res))
                    this.$store.commit('get_qr_permission', pathOr({}, ['qr_permission'], res))
                    // 权限判定
                    this.handlePermission()
                })
            } else {
                this.handlePermission()
            }
        },
        handlePermission() {
            let account_permission = this.$store.state.account_permission || {} 
            let hasPermission = this.FC_type === 'feedback' ? account_permission.feedback : account_permission.complaints 
            if (hasPermission) {
                this.init()
            } else {
                Toast({
                    message: '无权限',
                    icon: 'warning-o'
                })
                this.$router.push('/main')
            }
        },
        // 通过设备id获取相关设备信息 
        async getCustomerByEquip (id) { 
            let customerInfo = await getCustomerByEquipment({equipment_info_id: id})
            this.params.personalMsg.companyName = customerInfo.customer_name || this.params.personalMsg.companyName
            this.params.personalMsg.name = customerInfo.name || this.params.personalMsg.name
            this.params.personalMsg.phone = customerInfo.phone || this.params.personalMsg.phone
        },
        // 初始化
        async init() {
            this.loading = true
            if(this.$route.query.equipmentCode) {
                this.params.equipment_code = this.$route.query.equipmentCode
            }
            if(this.$route.query.equipmentId) {
                this.params.equipment_id = this.$route.query.equipmentId
                this.params.associatedObjectId = this.$route.query.equipmentId
            } 
            this.params.personalMsg.companyName = localStorage.getItem(location.host + 'company_name') || ''
            this.params.personalMsg.name = localStorage.getItem(location.host + 'user_name') || ''
            try {
                await this.getFeedbackType()
                await this.getSystemType()
                if (this.FC_type === 'complaints') {
                    await this.getComplainType()
                } 
                 // 从右侧菜单跳转过来
                if(this.$route.query.equipId) {
                    // 获取设备信息带过去
                    this.params.equipment_id = this.$route.query.equipId
                    this.params.associatedObjectId = this.$route.query.equipId
                    this.params.equipment_code = this.$route.query.equipCode
                    this.params.equipment_name = this.$route.query.equipmentName 
                    // 通过设备id获取相关设备信息 
                    this.getCustomerByEquip(this.$route.query.equipId)
                }
                this.saveCacheParams() 
            } catch (err) {
                this.loading = false
            }
            this.loading = false
        },
        // 保存带过来的参数
        saveRouteData() {
            // 保存选择页带过来的id
            this.params.associatedObjectId = this.$route.query.id || this.params.associatedObjectId || ''
            // 保存选择设备带过来的信息
            this.params.equipment_id = this.$route.query.id || this.params.equipment_id || ''
            this.params.equipment_code = this.$route.query.equipment_code || this.params.equipment_code || ''
            this.params.equipment_name = this.$route.query.equipment_name || this.params.equipment_name || ''
            if (this.$route.query.id && this.params.feedbackText === '设备') {
                // 通过设备id获取相关设备信息 
                this.getCustomerByEquip(this.$route.query.id)
            }
            // 保存选择配件带过来的信息
            this.params.accessoriesName =
                this.$route.query.accessoriesName || this.params.accessoriesName || ''
            this.params.accessoriesCode =
                this.$route.query.accessoriesCode || this.params.accessoriesCode || ''
            this.params.accessoriesModel =
                this.$route.query.accessoriesModel || this.params.accessoriesModel || ''
            // 保存服务单号
            this.params.serviceCode = this.$route.query.service_code || this.params.serviceCode || ''
            this.saveCacheParams() 
        },
        // 缓存表单信息
        saveCacheParams() {
            this.cacheParams = this.$clone(this.params)
        },
        // 获取反馈、投诉类型  设备、服务等
        getFeedbackType() {
            return new Promise((resolve, reject) => {
                let params = {
                    token: localStorage.getItem(location.host + 'token')
                    // token: 'f39237a5573541b7af7dc3b21f8c5f50' || localStorage.getItem(location.host + 'token')
                }
                if (this.FC_type === 'feedback') {
                    params.systemExist = 1 // 是否需要【系统】类型，反馈有【系统】类型，投诉没有
                }
                if (this.$store.state.isSlm) {
                    params.systemExist = 2 // 获取slm用户的类型  【2021-06-13】slm用户只能提交系统的反馈
                }
                get_feedback_type(params)
                    .then(res => {
                        this.opinionColumns = res || []
                        this.params.type =
                            this.opinionColumns[this.feedbackDefaultIndex] &&
                            this.opinionColumns[this.feedbackDefaultIndex].typeId
                        this.params.feedbackText =
                            this.opinionColumns[this.feedbackDefaultIndex] &&
                            this.opinionColumns[this.feedbackDefaultIndex].typeName
                        resolve()
                    })
                    .catch(err => {
                        this.opinionColumns = []
                        reject()
                    })
            })
        },
        // 获取投诉问题 质量问题、参数问题等
        getComplainType() {
            return new Promise((resolve, reject) => {
                let params = {
                    token: localStorage.getItem(location.host + 'token'),
                    // token: 'f39237a5573541b7af7dc3b21f8c5f50',
                    feedbackType: this.params.type
                }
                get_complain_type(params)
                    .then(res => {
                        this.complainColumns = res || []
                        this.params.complaintText = this.complainColumns[0]
                        resolve()
                    })
                    .catch(err => {
                        this.complainColumns = []
                        reject()
                    })
            })
        },
        showFCbox() {
            this.showFeedbackTypeSelect = true
        },
        // 获取系统终端
        getSystemType() {
            return new Promise((resolve, reject) => {
                get_feedback_type({
                    token: localStorage.getItem(location.host + 'token'),
                    // token: 'f39237a5573541b7af7dc3b21f8c5f50',
                    systemType: 1 // 获取类型为【系统终端】
                })
                    .then(res => {
                        this.systemTypeColumns = res || []
                        resolve()
                    })
                    .catch(err => {
                        this.systemTypeColumns = []
                        reject()
                    })
            })
        },
        // 反馈、投诉类型弹层--确认
        opinionOnConfirm(val) {
            this.params.feedbackText = val.typeName
            this.params.type = val.typeId
            this.showFeedbackTypeSelect = false
            if (this.FC_type === 'complaints') {
                this.getComplainType()
            }
        },
        // 反馈、投诉类型弹层--取消
        opinionOnCancel() {
            this.showFeedbackTypeSelect = false
        },
        // 系统终端弹层--确认
        systemTypeOnConfirm(val) {
            this.params.systemTypeText = val.typeName
            this.showSystemType = false
        },
        // 系统终端弹层--取消
        systemTypeOnCancel() {
            this.showSystemType = false
        },
        // 投诉问题弹层--确认
        complainOnConfirm(val) {
            this.params.complaintText = val
            this.showComplainType = false
        },
        // 投诉问题弹层--取消
        complainOnCancel() {
            this.showComplainType = false
        },
        // 表单提交
        async onSubmit() {
            if (!this.saveFlag) {
                return
            }
            this.saveFlag = false
            setTimeout(() => {
                this.saveFlag = true
            }, 1500)
            Toast.loading({
                message: '正在提交...',
                forbidClick: true,
                duration: 0
            })
            if (this.imgArr.length > 0 || this.videoArr.length > 0) {
                this.filesList = await _handleMedia(this.imgArr, this.videoArr)
            } else {
                this.filesList = []
            }
            this.sendRequest()
        },
        sendRequest() {
            let requestParams = {
                // token: 'f39237a5573541b7af7dc3b21f8c5f50',
                token: localStorage.getItem(location.host + 'token'),
                type: this.params.type, // 反馈、投诉类型 后台给的
                platformId: this.$store.state.platform_id, // 租户id，这个是必定有的
                content: this.params.feedbackContent, // 反馈、投诉内容
                files: this.filesList, // 附件
                user_name: this.params.personalMsg.name || '', // 客户名称
                company: this.params.personalMsg.companyName || '', // 公司名称
                phone: this.params.personalMsg.phone, // 电话号码
                isComplain: this.FC_type === 'feedback' ? 0 : 1, // 反馈、投诉类型，0-反馈  1-投诉
                origin: this.$store.state.account_origin === 'smas' ? 1 : 2, // 来源 1-盛云宝app  2-微信扫码
                // info: {}, // 每一个类型的独立信息，如配件-型号、品号，设备--设备编号，服务--服务单号 
            }
            if (this.FC_type === 'complaints') {
                requestParams.complaintType = this.params.complaintText // 投诉归类  这个是投诉才有的
            }
            // 1、设置每一个类型的独立信息，如配件-型号、品号，设备--设备编号，服务--服务单号
            // 2、对比表单信息与选择、扫码的缓存信息，不一样的要清空
            switch (this.params.type) {
                // 设备
                case 1:
                    if (this.params.equipment_code === this.cacheParams.equipment_code) {
                        requestParams.associatedObjectId = this.params.associatedObjectId
                        requestParams.source = this.params.associatedObjectId ? 'scan_qr' : '' // 设备对应的来源，scan_qr为扫码获取
                    } else {
                        this.params.equipment_name = ''
                    }
                    // 如果设备编号不存在清空
                    if (!this.params.equipment_code) {
                        requestParams.source = '' // 设备对应的来源，scan_qr为扫码获取
                        requestParams.associatedObjectId = ''
                    }
                    requestParams.info = {
                        equipment: {
                            name: this.params.equipment_name || '',
                            code: this.params.equipment_code || ''
                        }
                    }
                    break
                // 系统  只有反馈才有
                case 2:
                    if (this.FC_type === 'feedback') {
                        requestParams.info = {
                            system: {
                                name: this.params.systemTypeText || ''
                            }
                        }
                    }
                    break
                // 服务
                case 3:
                    if (this.params.serviceCode === this.cacheParams.serviceCode) {
                        requestParams.associatedObjectId = this.params.associatedObjectId
                    }
                    requestParams.info = {
                        service: {
                            code: this.params.serviceCode || ''
                        }
                    }
                    break
                // 人员
                case 4:
                    requestParams.info = {
                        staff: {
                            name: this.params.member || ''
                        }
                    }
                    break
                // 配件
                case 5:
                    if (
                        this.params.accessoriesName === this.cacheParams.accessoriesName &&
                        this.params.accessoriesCode === this.cacheParams.accessoriesCode &&
                        this.params.accessoriesModel === this.cacheParams.accessoriesModel
                    ) {
                        requestParams.associatedObjectId = this.params.associatedObjectId
                    }
                    requestParams.info = {
                        parts: {
                            name: this.params.accessoriesName || '',
                            code: this.params.accessoriesCode || '',
                            model_no: this.params.accessoriesModel || ''
                        }
                    }
                    break
                default:
                    break
            }

            feedbackInfo(requestParams)
                .then(res => {
                    Toast.clear()
                    if (res.code === 0) {
                        Toast('提交成功!')
                        let account_permission = JSON.parse(
                            localStorage.getItem(location.host + 'account_permission')
                        )
                        if (
                            (this.$store.state.account_origin !== 'not_staff' || this.$store.state.historyAccountType) &&
                            account_permission['feedback_complaints_list']
                        ) {
                            this.$router.push({
                                path: '/feedbackScreenList',
                                query: {
                                    from: 'feedbackScreen'
                                }
                            })
                        } else {
                            let from_path = getUrlKey('from_path') || (this.$route.query && this.$route.query.from_path) 
                            if (from_path === '/equipmentDetail') {
                                this.$router.push(from_path)
                            } else {
                                this.$router.push({
                                    path: '/main'
                                })
                            }
                        }
                    }
                })
                .catch(err => {
                    // Toast.clear()
                })
        },
        //点击选择设备
        $_selectEquipment() {
            //oem员工先去选客户
            if (this.$store.state.user_origin == 'oem') {
                this.$router.push({
                    path: '/custormerSearchScreen',
                    query: {
                        from: '/feedbackScreen',
                        FC_type: this.FC_type
                    }
                })
            } else {
                this.$router.push({
                    path: '/equitmentSearchScreen',
                    query: {
                        from: '/feedbackScreen',
                        FC_type: this.FC_type
                    }
                })
            }
        },
        // 选择服务单
        selectServiceorderFun() {
            this.$router.push({
                path: '/selectServiceOrder',
                query: {
                    fromType: this.FC_type
                }
            })
        },
        // 选择配件
        selectAccessoriesFun() {
            this.$router.push({
                path: '/selectAccessories',
                query: {
                    fromType: this.FC_type
                }
            })
        },
        scanStart() {
            let that = this
            console.log('点击扫码')
            // eslint-disable-next-line no-undef
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
                success: function(res) {
                    console.log('%c微信扫码配置成功!', 'color: green', res)
                    let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                    // 为了拿个url上的id，厉害厉害，鼓掌.jpg
                    that.equipment_id = (new RegExp('[?|&]' + 'id' + '=' + '([^&;]+?)(&|#|;|$)').exec(
                        result
                        // eslint-disable-next-line no-sparse-arrays
                    ) || [, ''])[1].replace(/\+/g, '%20')
                    get_qr_base_info({
                        // token: localStorage.getItem(location.host + 'token'),
                        equipment_id: that.equipment_id
                    }).then(res => {
                        that.params.equipment_name = pathOr('', ['equipment_name'], res)
                        that.params.equipment_code = pathOr('', ['equipment_code'], res)
                        that.params.associatedObjectId = pathOr('', ['id'], res)
                        that.params.equipment_id = pathOr('', ['id'], res)
                        that.saveCacheParams()
                    })
                }
            })
        },
        getImgArr(val) {
            this.imgArr = val
        },
        getVideoArr(val) {
            this.videoArr = val
        },
        is_Safari() {
            var ua = navigator.userAgent.toLocaleLowerCase()

            if (/safari/.test(ua) && !/chrome/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        async _uploadFile(fileData) {
            let type = fileData.name
            let key =
                getRandomCode(12) + encodeURI('one.' + type.substring(type.lastIndexOf('.') + 1, type.length))
            let dataParams = new FormData()
            let domain = `http://${document.domain}`
            let params = {} // 华为云配置参数
            params = (
                await get_file_upload_params({
                    key: key
                })
            ).params
            dataParams.append('policy', params.policy)
            dataParams.append('AccessKeyId', params.access_key_id)
            dataParams.append('signature', params.signature)
            dataParams.append('key', params.key)
            dataParams.append('file', fileData.file)
            dataParams.option = {
                header: {
                    Authorization: params.header_authorization,
                    Origin: domain
                }
            }
            return postHuaWeiOBS(dataParams).then(res => {
                return params.file_url
            })
        },
        // 验证电话
        validatorPhone(val) {
            if (val || val === 0) {
                return /^(\d|-|\/){1,30}$/g.test(val)
            } else {
                return true
            }
        },
        iosKeyboardDown() {
            window.scrollTo(0, 0)
        }
    }
}
</script>

<style lang="scss">
@import '../../assets/style/mixin';
::-webkit-scrollbar {
    display: none;
}
#feedback_container {
    @include fja(flex-start, flex-start);
    height: 100%;
    width: 100vw;
    flex-direction: column;
    font-weight: 400;
    font-family: PingFang SC;
    .b100 {
        padding-bottom: vw(100);
    }
    position: relative;
    .feedback_main {
        overflow-y: scroll;
        overflow-x: hidden;
        flex: 1;
        -webkit-overflow-scrolling: touch; //实现苹果手机的滚动回弹效果
        background: #f2f2f2;
        width: 100%;
        padding-bottom: vw(74);
        .img-container {
            background: #ffffff;
            padding: vw(15);
            .tip {
                width: 100%;
            }
        }
        .van-form {
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            padding: 0;
            .van-cell--required {
                .van-field__label {
                    padding-left: vw(10);
                }
                &::before {
                    left: 0;
                }
            }
            > div {
                padding: 0 vw(16) vw(6) vw(17);
                background: #fff;
                .van-cell.van-field {
                    font-size: vw(15);
                    display: flex;
                    flex-direction: column;
                    padding: 0;
                    .van-field__label {
                        margin-bottom: vw(2);
                        color: #333;
                        font-size: vw(14);
                    }
                    .van-field__value {
                        font-size: vw(13);
                        .van-field__body {
                            width: 100%;
                            border-bottom: vw(1) solid #eee;
                            padding-bottom: vw(6);
                        }
                    }
                    &::after {
                        display: none;
                    }
                }
                &:last-child {
                    ::v-deep .van-field {
                        margin: 0;
                        .van-field__value .van-field__body {
                            border: none;
                            padding-bottom: vw(0);
                        }
                    }
                }
            }
            > h3 {
                font-size: vw(16);
                color: #343434;
                font-weight: 500;
                padding: vw(10) 0 vw(10) vw(16);
                background: rgb(242, 242, 242);
            }
            // 反馈、投诉类型
            .form_feedbackType,
            .form_complainType {
                position: relative;
                .icon {
                    position: absolute;
                    right: vw(20);
                    bottom: vw(18);
                    display: block;
                    color: #333;
                }
            }
            // 设备编号
            .form_equipmentCode {
                position: relative;
                .van-field__control {
                    padding-right: vw(100);
                }
                .van-icon.van-icon-clear.van-field__clear {
                    position: absolute;
                    right: vw(85);
                    bottom: vw(11);
                    z-index: 50;
                }
                .select {
                    position: absolute;
                    right: vw(61);
                    bottom: vw(14);
                    // width: vw(30);
                    height: vw(30);
                    line-height: vw(30);
                    display: block;
                    z-index: 50;
                    color: #3d7bed;
                }
                .scan_img {
                    position: absolute;
                    right: vw(20);
                    bottom: vw(18);
                    width: vw(21);
                    height: vw(21);
                    display: block;
                    z-index: 100;
                }
            }
            // 服务单号、配件
            .form_serviceCode,
            .form_accessoriesName {
                position: relative;
                .van-field__control {
                    padding-right: vw(85);
                }
                .van-icon.van-icon-clear.van-field__clear {
                    position: absolute;
                    right: vw(61);
                    bottom: vw(11);
                    z-index: 50;
                }
                .select {
                    position: absolute;
                    right: vw(20);
                    bottom: vw(14);
                    width: vw(30);
                    height: vw(30);
                    line-height: vw(30);
                    display: block;
                    z-index: 50;
                    color: #3d7bed;
                }
            }
            // 附件
            .form_file {
                padding-top: vw(5);
                padding-bottom: vw(12);
                > p {
                    font-size: vw(14);
                    color: #333;
                    > span:last-child {
                        font-size: vw(11);
                        margin-left: vw(5);
                    }
                }
                .pictureOne,
                .picture_default1 {
                    width: 16vmin;
                    height: 16vmin;
                    .videoImg,
                    .videoImgAn,
                    .img1 {
                        width: 16vmin;
                        height: 16vmin;
                    }
                }
                .picture_default1 {
                    img {
                        width: 16vmin;
                        height: 16vmin;
                    }
                }
            }
            // 个人信息
            .person-title {
                font-size: vw(16);
                font-weight: 400;
                color: #333;
            }
            .form_personalMsg {
                padding-top: vw(8);
                padding-bottom: 0;
                > div:not(:last-child) {
                    padding-bottom: vw(5);
                }
            }
            // 提交
            .bottom-btn {
                position: absolute;
                z-index: 10;
                bottom: 0;
                @include fja(center, center);
                width: 100%;
                background: #ffffff;
                padding: vw(10) vw(16);
                padding-top: vw(10);
                .submit-btn {
                    height: vw(44);
                    width: 100%;
                    background: #3766e1;
                    font-size: vw(16);
                    color: #ffffff;
                    border-radius: vw(4);
                }
            }
        }
    }
    .successful {
        background: #ffffff;
        width: 100%;
        padding-left: vw(16);
        padding-right: vw(16);
        flex: 1;
        @include fja(center, center);
        flex-direction: column;
        .remind {
            width: vw(44);
            height: vw(28);
        }
        .successful-text {
            margin-top: vw(20);
            font-size: vw(16);
            color: #333333;
        }
        .thank {
            font-size: vw(14);
            color: #999999;
        }
        .thank:nth-of-type(2) {
            margin-top: vw(86);
        }
        .thank:nth-of-type(3) {
            margin-top: vw(10);
        }
    }
}
</style>
